export default __webpack_public_path__ + "static/media/RequestNewActive.44f504f8.svg";